module.exports = __webpack_public_path__ + "static/media/master.6a120841.svg";